module.exports = __webpack_public_path__ + "static/img/main5.c8a36937.png";